/* eslint-disable jira/filename-case */
export const DEFAULT_COLUMNS: string[] = [
	'issuetype',
	'issuekey',
	'summary',
	'reporter',
	'assignee',
	'status',
	'created',
];

export const DEFAULT_QUEUE_ID: number = Number.MIN_VALUE;

export const FETCH_SIZE_IN_INITIAL_LOAD = 30;
